import PageLayout from '@/pages/layout/PageLayout'
import AgGridSample from '@/pages/sample/AgGridSample'
import AmChartSample from '@/pages/sample/AmChartSample'

const children = [{
  path: '/sample/AgGridSample',
  name: 'AgGridSample',
  component: AgGridSample
}, {
  path: '/sample/AmChartSample',
  name: 'AmChartSample',
  component: AmChartSample
}]

export default [{
  path: '/',
  component: PageLayout,
  children
}]



// WEBPACK FOOTER //
// ./src/router/children/sample.js